import { Directive, OnInit } from '@angular/core';
import { Application } from '@modules/common/types/application';
import { VirtualFolder } from '@modules/notes/types/virtual-folder';
import { StateKey } from '@modules/settings/types/state-key';
import { NotesContextMenuComponent } from '../components/notes-context-menu/notes-context-menu.component';
import { DPContextMenuDirective } from './dp-context-menu.directive';

@Directive({
  selector: '[appDPNotesContextMenu]',
  standalone: false,
})
export class NotesContextMenuDirective
  extends DPContextMenuDirective<VirtualFolder, NotesContextMenuComponent>
  implements OnInit
{
  protected override readonly application = Application.notes;
  protected override readonly stateKey = StateKey.notesDPSidebarFilters;

  protected override registerComponent() {
    return NotesContextMenuComponent;
  }
}
